import React, { useEffect, useState } from "react";
import { getAPIURL, getVendorID } from "../../../services/helper";
import http from "../../../services/http";
import ReportPrintHeader from "../components/ReportPrintHeader";
import ReportPrintTable from "../components/ReportPrintTable";
import { Spinner } from "reactstrap";

const PrintEODReports = () => {
  const api_url = getAPIURL();
  const vendor_id = getVendorID();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!loading) {
      setTimeout(() => window.print(), 500);
    }
  }, [loading]);

  const fetchData = async () => {
    try {
      const { data } = await http.get(
        `${api_url}/reports/end-day?vendor_id=${vendor_id}`
      );
      setData(data);
    } catch (error) {
      console.error("Error loading EOD report for print:", error);
    }
    setLoading(false);
  };

  const columns = [
    { name: "Opened At", selector: (r) => r.opened_at },
    { name: "Closed At", selector: (r) => r.closed_at },
    { name: "Total Sales", selector: (r) => r.total_sales },
    { name: "Order Total", selector: (r) => r.total_amount },
    { name: "Discount", selector: (r) => r.total_discount },
    { name: "Tax", selector: (r) => r.total_tax },
  ];

  return (
    <div className="page-body">
      {loading ? (
        <div className="text-center mt-4">
          <Spinner color="primary" size="lg" />
          <p>Loading for Print...</p>
        </div>
      ) : (
        <>
          <ReportPrintHeader title="End of Day Reports" />
          <ReportPrintTable columns={columns} data={data} />
        </>
      )}
    </div>
  );
};

export default PrintEODReports;
